import classNames from 'classnames';
import styles from '../ApplicationInformation.module.scss';
import DomPurify from 'dompurify';

const AppInfoView = ({ selectedApp }) => {
	return selectedApp ? (
		<div className={styles.AppDetailsSection}>
			{selectedApp.appInfo.applicationName ? (
				<div className={classNames([styles.appName, styles.section])}>
					<div className={styles.detailLabel}>Application Name</div>
					<p className={styles.detailInfo}>
						{selectedApp.appInfo.applicationName}
					</p>
				</div>
			) : null}
			{selectedApp.appInfo.description ? (
				<div
					className={classNames([styles.description, styles.section])}
				>
					<div className={styles.detailLabel}>Description</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(
								selectedApp.appInfo.description
							),
						}}
					></p>
				</div>
			) : null}
			{selectedApp.appInfo.shortDescription ? (
				<div
					className={classNames([
						styles.shortDescription,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Short Description</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(
								selectedApp.appInfo.shortDescription
							),
						}}
					></p>
				</div>
			) : null}
			{selectedApp.appInfo.alias ? (
				<div className={classNames([styles.alias, styles.section])}>
					<div className={styles.detailLabel}>Alias</div>
					<p className={styles.detailInfo}>
						{selectedApp.appInfo.alias}
					</p>
				</div>
			) : null}

			{selectedApp.appInfo.training ? (
				<div className={classNames([styles.training, styles.section])}>
					<div className={styles.detailLabel}>
						Training Information
					</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(selectedApp.appInfo.training),
						}}
					></p>
				</div>
			) : null}

			{selectedApp.appInfo.typicalUsers ? (
				<div
					className={classNames([
						styles.typicalUsers,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Typical Users</div>
					<p className={styles.detailInfo}>
						{selectedApp.appInfo.typicalUsers}
					</p>
				</div>
			) : null}

			{selectedApp.appInfo.quickStart ? (
				<div
					className={classNames([styles.quickStart, styles.section])}
				>
					<div className={styles.detailLabel}>Next Steps</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(
								selectedApp.appInfo.quickStart
							),
						}}
					></p>
				</div>
			) : null}
			{selectedApp.appInfo.locations.displayFormattedLocations ? (
				<div className={classNames([styles.locations, styles.section])}>
					<div className={styles.detailLabel}>Locations</div>
					<p className={styles.detailInfo}>
						{
							selectedApp.appInfo.locations
								.displayFormattedLocations
						}
					</p>
				</div>
			) : null}
			{/* {selectedApp.appInfo.howToGet ? (
				<div className={classNames([styles.howToGet, styles.section])}>
					<div className={styles.detailLabel}>How To Get</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(selectedApp.appInfo.howToGet),
						}}
					></p>
				</div>
			) : null} */}
			{selectedApp.appInfo.help !== null ? (
				<div className={classNames([styles.help, styles.section])}>
					<div className={styles.detailLabel}>Support</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(selectedApp.appInfo.help),
						}}
					></p>
				</div>
			) : null}
			{selectedApp.appInfo.additionalInformation ? (
				<div
					className={classNames([
						styles.additionalInformation,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>
						Additional Information
					</div>
					<p
						className={styles.detailInfo}
						dangerouslySetInnerHTML={{
							__html: DomPurify.sanitize(
								selectedApp.appInfo.additionalInformation
							),
						}}
					></p>
				</div>
			) : null}
			{selectedApp.appInfo.managingDepartment ? (
				<div
					className={classNames([
						styles.managingDepartment,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>
						Managing Department
					</div>
					<p className={styles.detailInfo}>
						{selectedApp.appInfo.managingDepartment}
					</p>
				</div>
			) : null}
			{selectedApp.appInfo.securityContact &&
			selectedApp.appInfo.securityContact.displayFormattedContacts ? (
				<div
					className={classNames([
						styles.securityContact,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Security Contact</div>
					<p className={styles.detailInfo}>
						{
							selectedApp.appInfo.securityContact
								.displayFormattedContacts
						}
					</p>
				</div>
			) : null}
			{selectedApp.appInfo.privacyContact &&
			selectedApp.appInfo.privacyContact.displayFormattedContacts ? (
				<div
					className={classNames([
						styles.privacyContact,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Privacy Contact</div>
					<p className={styles.detailInfo}>
						{
							selectedApp.appInfo.privacyContact
								.displayFormattedContacts
						}
					</p>
				</div>
			) : null}
			{selectedApp.appInfo.owners &&
			selectedApp.appInfo.owners.displayFormattedContacts ? (
				<div className={classNames([styles.owners, styles.section])}>
					<div className={styles.detailLabel}>Owners</div>
					<p className={styles.detailInfo}>
						{selectedApp.appInfo.owners.displayFormattedContacts}
					</p>
				</div>
			) : null}
			{selectedApp.appInfo.technicalTeam &&
			selectedApp.appInfo.technicalTeam.displayFormattedContacts ? (
				<div
					className={classNames([
						styles.technicalTeam,
						styles.section,
					])}
				>
					<div className={styles.detailLabel}>Technical Team</div>
					<p className={styles.detailInfo}>
						{
							selectedApp.appInfo.technicalTeam
								.displayFormattedContacts
						}
					</p>
				</div>
			) : null}
		</div>
	) : null;
};

export default AppInfoView;
